import { useMemo } from 'react';

import usePagination from '@/hooks/usePagination';
import { useGetContentsQuery } from '@/modules/corporate/modules/admin/graphql/generated/contents';
import { ContentEntity, ContentFilters, Maybe, SortType } from '@/types/schema';

import { ENABLED_CONTENTS } from '../../const/contentType';

function useContents({
  filters,
  sort,
  pause,
  pageSize,
}: {
  filters: ContentFilters;
  sort?: Maybe<SortType[]>;
  pause?: boolean;
  pageSize?: number;
}) {
  const { data, isFetchingMore, error, refetch, fetchMore, isFetching, isLoading, totalCount } =
    usePagination(
      useGetContentsQuery,
      {
        filters,
        sort,
      },
      { pause, edgeKey: 'contents', requestPolicy: 'cache-and-network', pageSize },
    );

  const contents = useMemo(
    () => data.filter(({ __typename }) => ENABLED_CONTENTS[__typename]) as ContentEntity[], //todo can do undefined
    [data],
  );

  return {
    isFetching,
    isFetchingMore,
    isLoading,
    error,
    contents,
    totalCount,
    refetch,
    fetchMore,
  };
}

export default useContents;
